export class PageTransition {
    /**
        * Class constructor *
        * @arg {object} - `el` check for the body element.
    **/
    constructor (el) {
        if (!el) return;
        this.el = el;
        this.init();
    }

    init() {
        const self = this;

        // Remove page transition class on load to fade page in
        this.el.classList.remove('page-transition');
        

        // Add page transition on unload to fade page out
        window.onbeforeunload = function() {
            self.el.classList.add('page-transition');
        }
    }
}
